import { Vault } from '@/features/vaults/types';
import { LidoStrategyTitleHeader } from '@/shared/components/WhiteLabelTitleHeaders/LidoStrategyTitleHeader';

export const LidoStrategyVaultId = 'lido-strategy';
export const LidoStrategyVaultAddress = '0x277C6A642564A91ff78b008022D65683cEE5CCC5';

export const LidoStrategy: Vault = {
  id: LidoStrategyVaultId,
  type: 'core-vault',
  name: 'Lido stRATEGY',
  slogan: 'The infinite strategy engine',
  description:
    'Lido stRATEGY amplifies staking rewards by allocating liquidity across highly liquid and diversified DeFi opportunities, while strengthening the stETH ecosystem. All curator actions follow a pre-defined but continuously evolving set of controls, enabling flexible asset management with a high degree of transparency and integrity.',
  category: 'core-vault',
  address: LidoStrategyVaultAddress,
  whiteLabeling: {
    curatorId: 'mellow',
    subdomain: 'strategy',
    vaultTitleHeader: (
      <LidoStrategyTitleHeader link="https://stake.lido.fi/earn/strategy/deposit" />
    ),
  },
  curators: ['mellow'],
  operator: [],
  fees: [
    {
      type: 'performance',
      network: 'ethereum',
      curator: 'mellow',
      recipient: '0x277C6A642564A91ff78b008022D65683cEE5CCC5',
      amountPercent: 10,
      fromTimestamp: 1749592800,
    },
  ],
  points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: '0x277C6A642564A91ff78b008022D65683cEE5CCC5',
    },
    {
      network: 'plasma',
      vaultAddress: '0x841e213864046111E43d237703d71FaBe91Ef9e0',
    },
    {
      network: 'arbitrum',
      vaultAddress: '0x40330720039352B309c70A5028322D1481F496d1',
    },
  ],
  baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  lpTokenSymbol: 'strETH',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  additionalDepositTokens: [
    {
      address: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      decimals: 18,
      symbol: 'STETH',
      customDepositToken: { type: 'steth-wrap-wsteth' },
    },
  ],
  vaultTitleHeader: <LidoStrategyTitleHeader link="https://stake.lido.fi/earn/strategy/deposit" />,
  allocations: {
    showAllocationsTab: true,
    showAllocationsTable: true,
    debankBundleId: '218444',
    octavProLink: 'https://mellow.octav.fi/app/strETH',
  },
  displayNoMellowCuration: true,
};
